<template>
  <div class="col q-mb-lg">
    <model-table
      title="Price Card Items"
      :collection="priceCard.priceCardItems"
      :submodel="true"
      add-label="Item"
      :columns="[
        { field: 'type' },
        { field: 'description' },
        { field: 'price', },
        { name: 'actions', align: 'right' }
      ]"
      orderable
    >
      <price-card-item-form />
    </model-table>
  </div>
</template>

<script>

import PriceCard from 'src/models/showing/PriceCard'
import ModelTable from 'src/modules/admin/components/ModelTable'
import PriceCardItemForm from 'src/modules/admin/price-card/PriceCardItemForm'

export default {
  name: 'PriceCardItemTable',
  components: {
    ModelTable,
    PriceCardItemForm
  },
  props: {
    priceCard: {
      type: PriceCard,
      required: true
    }
  }
}

</script>
